<template>
  <div class="write-contract">
    <el-row :gutter="24">
      <!-- 左侧列表 -->
      <el-col :span="8">
        <div class="list-card" v-loading="loading">
          <div class="card-header">
            <div class="filter-buttons">
              <el-radio-group v-model="listType" size="small" @change="handleTypeChange">
                <el-radio-button label="public">大厅</el-radio-button>
                <el-radio-button label="mine">我的</el-radio-button>
              </el-radio-group>
            </div>
          </div>
          <div class="list-content">
            <div v-for="item in contractList" 
                 :key="item.id"
                 class="list-item"
                 :class="{ active: activeItem === item.id }"
                 @click="handleItemClick(item)">
              <div class="item-header">
                <div class="item-title">{{ item.catename }}</div>
                <el-tag size="small" type="info" v-if="item.status == '1' && item.lawyerid != 0">
                   处理中
                </el-tag>
                <el-tag size="small" type="success" v-if="item.status == '2' ">
                   已完成
                </el-tag>
              </div>
              <div class="item-info">
                <span>委托人：UID{{ item.uid }}</span>
                <span>{{ item.time }}</span>
              </div>
            </div>
            
            <!-- 分页器 -->
            <div class="pagination-container">
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageParams.page"
                :page-sizes="[10, 20, 30, 50]"
                :page-size="pageParams.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
      </el-col>

      <!-- 右侧详情 -->
      <el-col :span="16">
        <div class="detail-card" v-loading="detailLoading">
          <div class="card-header">
            合同详情
            <div class="header-actions" v-if="currentDetail">
              <!-- 根据状态显示不同的操作按钮 -->
              <el-button type="primary" 
                        size="small" 
                        v-if="currentDetail.status === 1 && currentDetail.lawyerid == 0"
                        @click="handleTakeOrder">
                接单
              </el-button>
            </div>
          </div>
          <div class="detail-content" v-if="currentDetail">
            <!-- 合同详情内容 -->
            <div class="detail-section">
              <h3>基本信息</h3>
              <div class="info-item">
                <span class="label">委托人：</span>
                <span>UID{{ currentDetail.uid }}</span>
              </div>
              <div class="info-item">
                <span class="label">订单号：</span>
                <span>{{ currentDetail.id }}</span>
              </div>
              <div class="info-item">
                <span class="label">下单时间：</span>
                <span>{{ currentDetail.time }}</span>
              </div>
              <div class="info-item" v-if="currentDetail.lawyerid != 0">
                <span class="label">接单律师：</span>
                <span>{{ currentDetail.lawyer }}</span>
              </div>
              <div class="info-item" v-if="currentDetail.lawyerid != 0">
                <span class="label">接单时间：</span>
                <span>{{ currentDetail.gettime }}</span>
              </div>
              <div class="info-item" v-if="currentDetail.status == '2'">
                <span class="label">完成时间：</span>
                <span>{{ currentDetail.dotime }}</span>
              </div>
            </div>

            <div class="detail-section">
              <h3>合同要求</h3>
              <div class="info-item">
                <span class="label">合同类型：</span>
                <span>{{ currentDetail.catename }}</span>
              </div>
              <div class="info-item">
                <span>{{ currentDetail.content }}</span>
              </div>
               
            </div>

            <!-- 合同内容编辑区域 -->
            <div class="detail-section" v-if="currentDetail.lawyerid != 0">
              <h3>合同内容</h3>
              <el-input
                v-model="currentDetail.ht"
                type="textarea"
                :rows="25"
                placeholder="请输入合同内容"
                :disabled="!currentDetail.canedit">
              </el-input>
              
              <!-- 添加上传和保存按钮 -->
              <div class="actions" v-if="currentDetail.canedit">
                <!-- 上传合同 -->
                <el-upload
                  class="upload-contract"
                  action="#"
                  :http-request="(params) => handleContractFileUpload(params)"
                  :on-error="handleUploadError"
                  :before-upload="beforeUpload"
                  :limit="1"
                  :file-list="fileList">
                  <el-button size="small" type="default" icon="el-icon-upload2">
                    上传合同附件
                  </el-button>
                  <div class="el-upload__tip" slot="tip">
                    只能上传 doc/docx 文件
                  </div>
                </el-upload>
                <div class="has-file"  v-if="currentDetail.fileurl && currentDetail.fileurl != '' && currentDetail.status == 2">
                    当前合同附件：<a :href="currentDetail.fileurl" target="_blank">{{ currentDetail.filename }}</a>
                </div>

                <!-- 保存按钮容器 -->
                <div class="save-button">
                  <el-button 
                    type="primary" 
                    @click="handleSaveContract"
                    :loading="saving">
                    保存合同
                  </el-button>
                </div>
              </div>
            </div>
          </div>
          <div class="empty-detail" v-else>
            请选择左侧合同查看详情
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import contractApi from '@/api/contract' // 需要创建此API文件
import caseApi from '@/api/case' // 需要创建此API文件

export default {
  name: 'WriteContract',
  data() {
    return {
      filename:'',
      fileurl:'',
      listType: 'public',
      loading: false,
      detailLoading: false,
      activeItem: null,
      contractList: [],
      currentDetail: null,
      pageParams: {
        page: 1,
        pageSize: 10
      },
      total: 0,
      saving: false,
      fileList: [], // 上传的文件列表
      uploadUrl: process.env.VUE_APP_BASE_API + '/upload/contract', // 上传地址
      uploadHeaders: {
        Authorization: 'Bearer ' + localStorage.getItem('token')
      }
    }
  },
  computed: {
    canEdit() {
      return this.currentDetail && 
             this.currentDetail.status == '2' &&
             this.listType === 'mine'
    }
  },
  created() {
    this.fetchContractList()
  },
  methods: {
    // 获取合同列表
    async fetchContractList() {
      try {
        this.loading = true
        const res = await contractApi.getContractList({
          ...this.pageParams,
          type: this.listType
        })
        if (res.status === 200) {
          this.contractList = res.data.list
          this.total = res.data.total
        }
      } catch (error) {
        this.$message.error('获取列表失败')
      } finally {
        this.loading = false
      }
    },

    // 获取合同详情
    async handleItemClick(item) {
      this.activeItem = item.id
      try {
        this.detailLoading = true
        const res = await contractApi.getContractDetail({ id: item.id })
        if (res.status === 200) {
          this.currentDetail = res.data
        }
      } catch (error) {
        this.$message.error('获取详情失败')
      } finally {
        this.detailLoading = false
      }
    },

    // 切换列表类型
    handleTypeChange() {
      this.pageParams.page = 1
      this.activeItem = null
      this.currentDetail = null
      this.fetchContractList()
    },

    // 分页处理
    handleSizeChange(val) {
      this.pageParams.pageSize = val
      this.pageParams.page = 1
      this.fetchContractList()
    },
    handleCurrentChange(val) {
      this.pageParams.page = val
      this.fetchContractList()
    },

    // 获取状态类型
    getStatusType(status) {
      const types = {
        1: 'warning',
        2: 'primary',
        3: 'success'
      }
      return types[status] || 'info'
    },

    // 获取状态文本
    getStatusText(status) {
      const texts = {
        1: '待接单',
        2: '进行中',
        3: '已完成'
      }
      return texts[status] || '未知'
    },

    // 接单处理
    async handleTakeOrder() {
      try {
        await this.$confirm('确定接单吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })

        const res = await contractApi.takeContract({ id: this.currentDetail.id })
        if (res.status === 200) {
          if(res.data.st === 2){
            this.$message.error('该订单已有人接单')
            await this.fetchContractList()
            this.currentDetail = null
            return
          }
          this.$message.success('接单成功')
          await this.fetchContractList()
          await this.handleItemClick(this.currentDetail)
        }

        // if(res.status === 400){
        //   this.$message.error(res.msg)
        //   await this.fetchContractList()
        //   this.currentDetail = null
        // }
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('接单失败')
        }
      }

    },

    // 上传合同附件
    async handleContractFileUpload(params) {
      console.log(params)
      const formData = new FormData();
      formData.append('file', params.file);
      formData.append('field_key', 'attachments');
      const response = await caseApi.uploadNodeFile(formData);
      console.log(response);
      if(response.status == 200){
        this.filename = params.file.name
        this.fileurl = response.data.url
        this.$message.success('上传成功')
      }else{
        this.handleUploadError()
      }
    },

    // 上传前验证
    beforeUpload(file) {
      const isValidType = ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(file.type)
      if (!isValidType) {
        this.$message.error('只能上传 Word 格式文件!')
        return false
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB!')
        return false
      }
      return true
    },

    // 上传成功回调
    // handleUploadSuccess(response, file, fileList) {
    //     console.log(response,'response')
    //     console.log(file,'file')
    //     console.log(fileList,'fileList')
    //   if (response.status === 200) {
    //     this.fileList = fileList
    //     this.filename = file.name
    //     this.fileurl = response.data.path
    //     this.$message.success('上传成功')
    //   } else {
    //     this.handleUploadError()
    //   }
    // },

    // 上传失败回调
    handleUploadError() {
      this.$message.error('上传失败，请重试')
      this.fileList = []
    },

    // 修改保存合同方法，添加附件信息
    async handleSaveContract() {
      if (!this.currentDetail.ht?.trim()) {
        this.$message.warning('请输入合同内容')
        return
      }

      try {
        this.saving = true
        const res = await contractApi.submitContract({
          id: this.currentDetail.id,
          ht: this.currentDetail.ht,
          filename:this.filename,
          fileurl: this.fileurl
        })
        
        if (res.status === 200) {
          this.$message.success('保存成功')
          // 重新获取详情
          await this.handleItemClick(this.currentDetail)
        }
      } catch (error) {
        this.$message.error('保存失败，请重试')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.write-contract {
  .list-card,
  .detail-card {
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    height: calc(100vh - 230px);
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .card-header {
      padding: 16px;
      font-weight: 500;
      border-bottom: 1px solid #f0f0f0;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }

  .list-content {
    flex: 1;
    overflow-y: auto;
    padding: 0 16px;

    .list-item {
      padding: 16px;
      border-bottom: 1px solid #f0f0f0;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background: #f5f5f5;
      }

      &.active {
        background: #e6f7ff;
      }

      .item-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 8px;

        .item-title {
          font-weight: 500;
          color: #262626;
        }
      }

      .item-info {
        font-size: 13px;
        color: #8c8c8c;
        display: flex;
        justify-content: space-between;
      }
    }
  }

  .detail-content {
    padding: 20px;
    height: calc(100% - 57px);
    overflow-y: auto;

    .detail-section {
      margin-bottom: 24px;

      h3 {
        font-size: 16px;
        margin: 0 0 16px 0;
        color: #262626;
      }

      .info-item {
        margin-bottom: 12px;
        line-height: 1.5;
        color: #333;

        .label {
          color: #8c8c8c;
          margin-right: 8px;
        }
      }
    }
  }

  .empty-detail {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #8c8c8c;
  }

  .pagination-container {
    padding: 16px;
    text-align: center;
    background: #fff;
    border-top: 1px solid #f0f0f0;
  }

  .filter-buttons {
    .el-radio-group {
      display: flex;
      :deep(.el-radio-button__inner) {
        border-radius: 0;
      }
      :deep(.el-radio-button:first-child .el-radio-button__inner) {
        border-radius: 4px 0 0 4px;
      }
      :deep(.el-radio-button:last-child .el-radio-button__inner) {
        border-radius: 0 4px 4px 0;
      }
    }
  }

  .actions {
    .upload-contract {
      margin: 16px 0;
      
      .el-upload__tip {
        font-size: 12px;
        color: #909399;
        margin-top: 4px;
      }
    }

    .save-button {
      margin-top: 16px;
      text-align: right;
    }
  }
}
.has-file{
  margin-top: 16px;
  color: #777777;
}
.has-file a{
  color: #666666;
}
</style> 